module.exports = __webpack_public_path__ + "img/0.70692a1b.gif";